module.exports = __webpack_public_path__ + "img/step7.3870fe00.png";